import React from "react";
import { Box, Card, CardContent, Typography } from "@mui/material";
import { ProfilCardItem } from "../../../types";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

type ProfilCardProps = {
    profilCardItem: ProfilCardItem;
};

export default function ProfilCard({ profilCardItem }: ProfilCardProps) {
    const { label, value, onClick } = profilCardItem;

    return (
        <Card
            sx={{
                display: "flex",

                padding: "1rem",
                alignItems: "center",
                gap: "1rem",
                alignSelf: "stretch",
                borderRadius: "1rem",
                background: "#FFF",
                /* Ombre card */
                boxShadow: "0px 4px 30px 0px #E3E6E8",
            }}
        >
            <CardContent
                sx={{
                    padding: 0,
                    ":last-child": {
                        paddingBottom: 0,
                    },
                    display: "flex",
                    flexDirection: "row",
                    gap: "1rem",
                    width: "100%",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "flex-start",
                        flexDirection: "column",
                        flex: "1 0 0",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",

                            alignItems: "center",

                            alignSelf: "stretch",
                        }}
                    >
                        <Typography
                            sx={{
                                color: "#023",

                                fontFamily: "Roboto",
                                fontSize: "0.875rem",
                                fontStyle: "normal",
                                fontWeight: "500",
                                lineHeight: "150%",
                            }}
                        >
                            {label}
                        </Typography>
                    </Box>
                    <Typography
                        sx={{
                            color: "#023",

                            fontFamily: "Roboto",
                            fontSize: "0.75rem",
                            fontStyle: "normal",
                            fontWeight: "400",
                            lineHeight: "1.25rem",
                        }}
                    >
                        {value}
                    </Typography>
                </Box>
            </CardContent>
            {onClick ? (
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.625rem",
                        alignSelf: "stretch",
                    }}
                    onClick={() => {
                        if (onClick) {
                            onClick();
                        }
                    }}
                >
                    <ChevronRightIcon
                        width="1.125rem"
                        height="1.125rem"
                        sx={{
                            // ":hover": {
                            //     transform: "rotate(90deg)",
                            // },
                            cursor: "pointer",
                            float: "left",
                        }}
                    />
                </Box>
            ) : null}
        </Card>
    );
}
